/**
 * Acciones para la edición de producto en la gestión de productos
 * gp_ep_ = Gestión de Producto (gp) _ Editar Producto (ep)
 */

import { Dispatch } from "react";
import * as http from "../../../api/http";
import { ENDPOINTS } from "../../../api/config";
import { State } from "../../../reducers";
import {
  generalOpenModalError,
  generalOpenModalMessage,
  generalShowLoader,
} from "../../general.actions";
import { GESTION_PRODUCTOS_TYPES } from "../../../constants/gestionProducto.types";
import { GestionProducto, GestionProductoAction } from "../../../interfaces/gestion-Productos.interfaces";
import { validacionesCodigoOnBlurProducto } from "../gp_generales.ts/gp_generales";
import * as validators from '../../../utils/validaciones'
import { DICCIONARIO } from "../../../constants/Diccionario";
import { KEYS } from "../../../constants/keysStorage";
import { getProductos } from "../agregar-producto/agregarProductoFile.actions";

// ******************************************************************************************
// ? ACCIONES BÁSICAS
// ******************************************************************************************
const gp_ep_FormEditarHandleChange = (formProduct: any) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_HANDLE_CHANGE,
  payload: formProduct,
});

export const gp_ep_AddError = (error: any) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_ADD_ERROR,
  payload: error,
});

export const gp_ep_SetProductoSeleccionado = (producto: any) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_SET_PRODUCTO_SELECCIONADO,
  payload: producto,
});

//esto es lo ultimo qe agregue aca
export const gp_ep_ClearFormOnly = () => ({
  type: GESTION_PRODUCTOS_TYPES.EP_FORM_CLEAR_FORM_ONLY,
  payload: null,
});

export const gp_ep_HandleChange = (formProduct: any) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_HANDLE_CHANGE,
  payload: formProduct,
})



export const gp_ep_ChangePage = (num: number) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_FORM_CHANGE_PAGE,
  payload: num,
})//hasta este es lo ultimo que agregue


export const gp_ep_Clear = () => ({
  type: GESTION_PRODUCTOS_TYPES.EP_CLEAR,
  payload: null,
});

export const gp_ep_SetSucursalesAsignadas = (sucursales: string[]) => ({
    type: GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES_ASIGNADAS,
    payload: sucursales,
});

export const gp_ep_SetSucursales = (sucursales: any) => ({
  type: GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES,
  payload: sucursales,
})


// ******************************************************************************************
// ? ABRIR MODAL DE EDICIÓN
// ******************************************************************************************
  export const gp_ep_OpenEditar =
  (producto: any) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {

    // Calcular precioSinIVA e IVA directamente
    const precioUnitario = parseFloat(producto.precioUnitario) || 0;
    const precioSinIVA = precioUnitario > 0 ? (precioUnitario / 1.13).toFixed(2) : "0.00";
    const iva = precioUnitario > 0 ? (precioUnitario - parseFloat(precioSinIVA)).toFixed(2) : "0.00";

    // Formatear producto para el store
    const formateado = {
      ...producto,
      tipoItem:
        producto.servicioProducto === "1" || producto.servicioProducto === "producto"
          ? "1"
          : "0",
      impuestoDistintoAlIVA:
        Array.isArray(producto.impuestoDistintoAlIVA) && producto.impuestoDistintoAlIVA.length > 0
          ? String(producto.impuestoDistintoAlIVA[0])
          : "",
      unidadMedida: producto.unidadMedida ? String(producto.unidadMedida) : "",
      precioSinIVA,
      iva,
    };

    // Actualizar producto seleccionado en el store
    dispatch({
      type: GESTION_PRODUCTOS_TYPES.EP_SET_PRODUCTO_SELECCIONADO,
      payload: formateado,
    });

    // Preparar objeto para llenar formulario
    const prod = {
      idproducto: producto?.idproducto || "",
      codigoProducto: producto?.codigoProducto || "",
      descripcion: producto?.descripcion || "",
      precioUnitario: precioUnitario.toString(),
      precioSinIVA,
      iva,
      servicioProducto: producto?.servicioProducto || "0",
      unidadMedida: producto?.unidadMedida ? String(producto.unidadMedida) : "",
      impuestoDistintoAlIVA:
        Array.isArray(producto.impuestoDistintoAlIVA) && producto.impuestoDistintoAlIVA.length > 0
          ? String(producto.impuestoDistintoAlIVA[0])
          : "",
      tipoItem:
        producto.servicioProducto === "1" || producto.servicioProducto === "producto"
          ? "1"
          : "0",
    };

    // Llenar formulario en el store
    await dispatch(gp_ep_FormEditarHandleChange(prod));
  };


  export const gp_ep_getSucursales = (idproducto: number) =>
  async (dispatch: Dispatch<GestionProductoAction>) => {
    const message = "Existió un inconveniente al obtener las sucursales"

    await http
      .post(ENDPOINTS.GESTION_PRODUCTO_POST_SUCURSALES, { idproducto }, {}, KEYS.TOKEN)
      .then(async (res: any) => {

        if (!res?.message) {
          dispatch(gp_ep_SetSucursales(res.body))
          return;
        }

        await dispatch(generalOpenModalError(res.message ?? message))
        dispatch(gp_ep_SetSucursales([]));
      });
  }
// ******************************************************************************************
// ? CONFIRMAR EDICIÓN DE PRODUCTO
// ******************************************************************************************
export const gp_ep_EditarProducto =
  (history: any, precioCambiado: boolean) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    if (getState().general.loader) return;
    await dispatch(generalShowLoader(true));

    const state = getState().gestionProducto.editarProducto;
    const formProduct = state.formProduct;
    const sucursalesAsignadas = state.sucursalesAsignadas;
    const productoSeleccionado = state.productoSeleccionado;

    if (!productoSeleccionado?.idproducto) {
      await dispatch(
        generalOpenModalError("No se pudo obtener el ID del producto.")
      );
      await dispatch(generalShowLoader(false));
      return;
    }

    if (!sucursalesAsignadas || sucursalesAsignadas.length === 0) {
      await dispatch(
        generalOpenModalError("Debe seleccionar al menos una sucursal.")
      );
      await dispatch(generalShowLoader(false));
      return;
    }

    const { catalogos } = state;
    const sucursalesActivas = catalogos.sucursales.filter(
      (s: any) => s.activo === "true" && s.eliminado !== "1"
    );

    const actualizarProductoGeneral =
      precioCambiado && sucursalesAsignadas.length === sucursalesActivas.length;

    const body: any = {
      idproducto: Number(productoSeleccionado.idproducto),
      actualizarProductoGeneral,
      precioUnitarioGeneral: actualizarProductoGeneral
        ? Number(formProduct.precioUnitario || 0)
        : null,
      productoSucursal: sucursalesAsignadas.map((idSucursal: any) => {
    const sucursalData: any = {
        idsucursal: Number(idSucursal),
        clave: formProduct.codigoProducto?.trim(),
        descripcion: formProduct.descripcion?.trim(),
        tipoitem: formProduct.tipoItem || "0",
        unidad: formProduct.unidadMedida || "",
        usuariomodificacion: localStorage.getItem(KEYS.USERNAME_CLIENTE) || "desconocido",
        impuestos: formProduct.impuestoDistintoAlIVA ? [Number(formProduct.impuestoDistintoAlIVA)] : [],
    };

    if (precioCambiado) {
        sucursalData.preciounitario = Number(formProduct.precioUnitario || 0);
    }

      return sucursalData;
    }),
    };

    const message =
      "Existió un inconveniente al editar la información del producto, intente nuevamente.";
    try {
      const res: any = await http.post(
        ENDPOINTS.GESTION_PRODUCTO_UPDATE_INFO,
        body
      );

      if (res.errorCode === 0) {
        await dispatch(
          generalOpenModalMessage(
            "Producto Actualizado",
            "Se actualizó la información del producto correctamente."
          )
        );
        history.push("/gestion-productos/listar-productos");
      } else {
        await dispatch(generalOpenModalError(res?.message ?? message));
      }
    } catch (err: any) {
      await dispatch(
        generalOpenModalError(
          err?.response?.data?.message ?? message,
          err?.response?.data?.status
        )
      );
    } finally {
      await dispatch(generalShowLoader(false));
    }
  };

  export const gp_ep_validacionesEditarProducto =
  () =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    const { formProduct, formErrorProduct } = getState().gestionProducto.editarProducto;

    const camposObligatorios = [
      'codigoProducto',
      'descripcion',
      'unidadMedida',
      'precioUnitario',
      'tipoItem'
    ];

    let tieneError = false;
    const errores: any = {};

    camposObligatorios.forEach((campo) => {
      const valor =
        formProduct && typeof formProduct === 'object' ? (formProduct as any)[campo] : '';
      if (valor === undefined || valor === null || valor.toString().trim() === '') {
        errores[campo] = 'Este campo es obligatorio';
        tieneError = true;
      } else {
        errores[campo] = '';
      }
    });

    if (tieneError) {
      dispatch({
        type: GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_ADD_ERROR,
        payload: errores,
      });
      return true;
    }

    const hasErrors = Object.values(formErrorProduct || {}).some(
      (value) => typeof value === 'string' && value.trim() !== ''
    );

    if (hasErrors) return true;

    return false;
  };


export const gp_ep_FormEditarHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    let { name, value } = e.target;

    if (name === "precioUnitario") {
      // Permitir solo números y punto decimal
      value = value.replace(/[^0-9.]/g, "");

      // Evitar más de un punto decimal
      const parts = value.split(".");
      if (parts.length > 2) value = parts[0] + "." + parts[1];

      // Limitar a dos decimales si los hay
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + "." + parts[1].slice(0, 2);
      }

      const precioUnitarioNum: number | "" = value === "" ? "" : parseFloat(value);

      let precioSinIVA: number | "" = "";
      let iva: number | "" = "";

      if (precioUnitarioNum !== "") {
        const ivaRate = 0.13;
        precioSinIVA = parseFloat((precioUnitarioNum / (1 + ivaRate)).toFixed(2));
        iva = parseFloat((precioUnitarioNum - precioSinIVA).toFixed(2));
      }

      dispatch(
        gp_ep_FormEditarHandleChange({
          precioUnitario: value, // mantiene el valor exacto en el input
          precioSinIVA,
          iva,
        })
      );
      return;
    }

    switch (name) {
      case "codigoProducto":
        dispatch(
          gp_ep_FormEditarHandleChange({
            [name]: String(value).trim().toUpperCase(),
          })
        );
        break;

      default:
        dispatch(gp_ep_FormEditarHandleChange({ [name]: value }));
        break;
    }
  };


////////// funciones o procedimiento sin peticiones res
export const gp_ep_FormHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    let { name, value } = e.target


  // Validación personalizada para productos
  const mensajeError = validacionesOnBlurProducto(name, value)
  dispatch(gp_ep_AddError({ [name]: mensajeError }))
  // Siempre actualizar el valor, aunque haya error

    // Ejemplo de lógica especial para campos numéricos
    if (["precioUnitario", "precioSinIVA", "iva", "impuestoDistintoAlIVA"].includes(name)) {
      value = value.replace(/[^0-9.]/g, "")
      dispatch(gp_ep_HandleChange({ [name]: value === '' ? 0 : Number(value) }))
      return
    }
    // Ejemplo de lógica especial para mayúsculas en códigoProducto
    if (name === 'codigoProducto') {
      dispatch(gp_ep_HandleChange({ [name]: String(value).toUpperCase() }))
      return
    }
    dispatch(gp_ep_HandleChange({ [name]: value }))
  }
  // editarProducto.actions.ts
export const gp_ep_SetFormProduct = (producto: any) => (dispatch: any) => {
    dispatch({
        type: 'GP_EP_SET_FORM_PRODUCT',
        payload: producto
    });
};


  //////////// validaciones
  export const gp_ep_ValidacionesFormOnBlur =
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
      let { name, value } = e.target
      let message = ''
  
      if (!value) message = 'Este campo es obligatorio'
      if (name === 'precio' && Number(value) < 0) message = 'El precio debe ser mayor a 0'
  
      dispatch(gp_ep_AddError({ [name]: message }))
    }

    export const validacionesOnBlurProducto = (name: string, value: any) => {
      let message = ''
      switch (name) {
        case 'sucursal':
          message = validators.validacionEsRequerido(value, message)
          break
        case 'codigoSucursal':
          message = validators.validacionEsRequerido(value, message)
          break
        case 'codigoProducto':
          message = validators.validacionEsRequerido(value, message)
          break
        case 'precioUnitario':
          message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRECIO_UNITARIO)
          if (!message) message = validators.validacionNumMinimo(value,0)
          break
        case 'precioSinIVA':
          message = validators.validacionEsRequerido(value, message)
          if (!message) message = validators.validacionNumMinimo(value, 0)
          break
        case 'iva':
          message = validators.validacionEsRequerido(value, message)
          if (!message) message = validators.validacionNumMinimo(value, 0)
          break
        case 'servicioProducto':
          message = validators.validacionEsRequerido(value, message)
          break
        case 'unidadMedida':
          message = validators.validacionEsRequerido(value, message)
          break
        case 'descripcion':
          message = validators.validacionEsRequerido(value, message)
          if (!message && value.length > 80) message = 'La descripción no puede exceder 80 caracteres';
          break
        case 'impuestoDistintoAlIVA':
          if (value !== null && value !== undefined && value !== '') {
            if (!message) message = validators.validacionNumMinimo(value, 0)
          }
          break
        default:
          break
      }
      return message
    }
    